/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Hero_OverlineInputs */

const en_rd_hero_overline = /** @type {(inputs: Rd_Hero_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FREE REPO CHECK`)
};

const id_rd_hero_overline = /** @type {(inputs: Rd_Hero_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CEK REPO GRATIS`)
};

/**
* | output |
* | --- |
* | "FREE REPO CHECK" |
*
* @param {Rd_Hero_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_hero_overline = /** @type {((inputs?: Rd_Hero_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Hero_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_hero_overline(inputs)
	return en_rd_hero_overline(inputs)
});